<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CCard bodyWrapper>
          <CRow>
            <CCol  lg="4" sm="12" v-for="r in reports">
              <CButton color="success"
                   class="w-75 h-75 m-2"

                  @click="getDateModal(r)">
              {{ r}}
              </CButton>

            </CCol>

          </CRow>
          <modal name="date-picker-modal" height="600px" :adaptive="true">
            <div class="m-3 p-3">
              <CRow class="p-2 border-bottom">
                <h4>Export Report</h4><br><br>
              </CRow>
              <CRow class="p-5 h-100">
                <CCol>
                  <VueCtkDateTimePicker v-show="(selected_report!=='Unsubscribed Report')"
                      :overlay=true
                      :range=true
                      :no-label=true
                      label="Select"
                      id="RangeDatePicker"
                      format="YYYY-MM-DD"
                      formatted="ll"
                      color="#0097FE"
                      v-model="date_range"
                  >
                  </VueCtkDateTimePicker>
                  <h6 class="my-3">Report : <b>{{selected_report}}</b></h6>
                  <CFormGroup label="Select Promo" v-show="selected_report==='Order Report of a Promo'">
                    <multiselect
                        v-model="coupon"
                        :options="promos"
                        placeholder="Select one"
                        label="code"
                        track-by="id"
                    >
                    </multiselect>
                  </CFormGroup>
                  <CFormGroup label="Select Category" v-show="selected_report==='Order Report of a Subcategory'">
                    <multiselect
                        v-model="category"
                        :options="categories"
                        placeholder="Select one"
                        label="name"
                        track-by="id"
                        @input="getSubcategories"
                    >
                    </multiselect>
                  </CFormGroup>
                  <CFormGroup label="Select Subcategory" v-show="selected_report==='Order Report of a Subcategory'">
                    <multiselect
                        v-model="subcategory"
                        :options="subcategories"
                        placeholder="Select one"
                        label="name"
                        track-by="id"
                    >
                    </multiselect>
                  </CFormGroup>
                  <CFormGroup label="Select Date Type" v-show="selected_report==='In-House SP Orders'">
                    <select class="form-control" v-model="date_type">
                      <option value="scheduled_date">Scheduled Date</option>
                      <option value="created_at">Created Date</option>
                    </select>
                  </CFormGroup>
                  <CButton class="center-div btn-block " color="primary" @click="exportReport">Export</CButton>
                  <CButton class="center-div btn-block  mt-1" color="dark" @click="closeModal">Cancel</CButton>
                  <CSpinner variant="danger" label="Spinning" v-if="exporting"></CSpinner>
                </CCol>
              </CRow>
            </div>
          </modal>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import axios from "axios";
import moment from "moment";
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: 'Reports',
  data() {
    return {
      warningModal: false,
      date_range: '',
      date_type: 'scheduled_date',
      selected_report: '',
      exporting: false,
      coupon: {
        id: ''
      },
      subcategory: {
        id: ''
      },
      category: {
        id: ''
      },
      categories: [],
      subcategories: [],
      promos: [],
      reports: [
        'Revenue Report',
        'Unsubscribed Report',
        // 'Users Report',
        // 'Subscribers Report',
      ]
    }
  },
  created() {
    this.getCoupons();
    this.getCategories();
  },
  methods: {
    getDateModal(report){
      this.$modal.show('date-picker-modal');
      this.selected_report = report
    },
    closeModal(){
      this.$modal.hide('date-picker-modal');
    },

    // getCoupons(){
    //   axios.get(`${ADMIN_URL}/all-promos`, {
    //     params : {
    //       type : 'all'
    //     }
    //   })
    //       .then(response =>{
    //         this.promos = response.data;
    //       })
    //       .catch( e=>{
    //         //console.log("error occurs");
    //       });
    // },
    // getCategories() {
    //   axios.get(`${ADMIN_URL}/all-categories`)
    //       .then(response => {
    //         this.categories = response.data;
    //       })
    //       .catch(e => {
    //         //console.log("error occurs");
    //       });
    // },
    // getSubcategories() {
    //   axios.post(`${ADMIN_URL}/subcategories`, {
    //     category_id: this.category.id
    //   })
    //       .then(response => {
    //         this.subcategories = response.data;
    //       })
    //       .catch( e => {
    //         //console.log("error occurs");
    //       });
    //
    // },
    exportReport(){
      this.exporting = true;
      axios({
        method: 'post',
        url: `${ADMIN_URL}/export-report`,
        responseType: 'blob',
        data: {
          date_range: this.date_range,
          report: this.selected_report,
          // coupon_id: this.coupon.id,
          // subcategory_id: this.subcategory.id,
          // date_type: this.date_type
        }
      })
          .then(response => {
            console.log(response.data);
            this.exporting = false;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.selected_report+'_' + moment(this.date_range.start).format('YYYY-MM-DD') + '~' + moment(this.date_range.end).format('YYYY-MM-DD') +'.xlsx');
            document.body.appendChild(link);
            link.click();
            this.$swal('Report Exported Successfully', '', 'success');
            this.closeModal();
          })
          .catch(e => {
            this.exporting = false;
            console.log("error occurs",e);
            this.$swal('Error', 'Something Went Wrong', 'error');
          });
    }
  },


}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
}
.test-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}
</style>
